<script>

export default {
    name: "PrescriptionTab",

    props: {
        prescriptions: Array,
        noneDrugTreatments: Array,
        encounters: Array,
    },

    methods: {

      printMedicalFile() {
          window.print();
      },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="w-full p-1 hide--print">
            <span class="py-px px-3 font-medium bg-blue-800 text-white rounded text-xs mr-2">Inpatient</span>
            <span class="py-px px-3 font-medium bg-blue-400 text-white rounded text-xs mr-2">Outpatient</span>
            <span class="py-px px-3 font-medium bg-yellow-500 text-white rounded text-xs mr-2">Triage</span>
            <span class="py-px px-3 font-medium bg-green-500 text-white rounded text-xs mr-2">Discharge</span>
        </div>
        <div class="w-full" v-for="encounter in [...encounters, {encounterId: 0}]" :key="encounter.encounterId">
            <div class="p-1 w-full rounded-t-md"
                :class="{
                    'bg-blue-400': encounter.category == `OutPatient`,
                    'bg-blue-800' : encounter.category == `InPatient`,
                    'bg-yellow-500' : encounter.category == `Triage`,
                }"
                v-if="(prescriptions.length && 
                    prescriptions.filter(pres => encounter.encounterId==pres.encounterID).length) ||
                    (noneDrugTreatments.length && 
                    noneDrugTreatments.filter(nDT => nDT.encounterID==encounter.encounterId).length)">
                <h5 class="font-bold text-white text-sm">
                    Encounter #{{ encounter.encounterId }} Visit #{{encounter.visitNo}}</h5>
            </div>
            <div class="p-1 border w-full flex flex-wrap my-px" v-if="prescriptions.length && 
                    prescriptions.filter(pres => encounter.encounterId==pres.encounterID).length">
                <div class="md:w-1/5 w-1/4">
                    <h5 class="font-bold text-lg">Prescriptions</h5>
                </div>
                <div class="md:w-4/5 w-3/4">
                    <table class="table">
                        <thead class="text-sm bg-gray-200">
                            <tr>
                                <th class="p-tiny">Date</th>
                                <th class="p-tiny">Drug</th>
                                <th class="p-tiny">Prescription</th>
                                <th class="p-tiny">Qty</th>
                                <th class="p-tiny">Doctor</th>
                            </tr>
                        </thead>
                        <tbody class="text-xs bg-gray-100">
                            <tr v-for="(prescription,idx) in prescriptions.filter(pres => encounter.encounterId==pres.encounterID)" 
                                :key="idx">
                                <td class="p-tiny">{{ prescription.date | dateFormat }}</td>
                                <td class="p-tiny">{{ prescription.drug }}</td>
                                <td class="p-tiny">{{ prescription.description }}</td>
                                <td class="p-tiny">{{ prescription.totalDosage }}</td>
                                <td class="p-tiny">{{ prescription.requested_By }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="w-full border flex flex-wrap my-px" 
                v-if="noneDrugTreatments.length && 
                    noneDrugTreatments.filter(nDT => nDT.encounterID==encounter.encounterId).length">
                <div class="md:w-1/5 w-1/4 p-1">
                    <h5 class="font-bold text-lg">None Drug Treatment</h5>
                </div>
                <div class="md:w-4/5 w-3/4 p-1">
                    <div class="my-px" 
                        v-for="noneDrugTreatment in 
                            noneDrugTreatments.filter(nDT => nDT.encounterID==encounter.encounterId)" 
                        :key="noneDrugTreatment.id">
                        <span v-html="noneDrugTreatment.description"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full p-1 text-right">
            <button 
            @click.prevent="printMedicalFile"
            class="btn-sm btn-primary text-xs">
                <i class="fa fa-print"></i> Print</button>
        </div>
    </div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
        }
    }
</style>
